export default __webpack_public_path__ + "content/media/24.49f60f5d.jpg";